//#region Angular Imports

import { StateService, StateProvider } from '@uirouter/angularjs'

//#endregion

import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'
import { default as commonModule, LoggerService } from './../common/common.module'
import { OpOperator } from '../../models/core'
import { Activity, Enums } from '../../models/common'

import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'
import { UserSession, ConfigHelper } from '../../helpers'
import { TARIFF_SERVICE_NAME, TariffService } from '../../services/tariff'
import { SERVICES_MODULE_NAME } from './../../services'
import { PROVIDER_NAME as SYSTEM_SERVICE_PROVIDER_NAME, SystemServiceProvider, $STATE_SERVICE_NAME, $SCOPE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, $STATE_SERVICE_PROVIDER_NAME } from '../../services/system'
import { GRID_SERVICE_NAME, GridService, GridContextMenuService, GRID_CONTEXT_MENU_SERVICE_NAME } from '../../services/grid'
import { USER_SESSION_SERVICE_NAME, UserSessionService, USER_SESSION_SERVICE_PROVIDER_NAME } from '../../services/user-session'
import { SYSTEM_SERVICE_NAME, SystemService } from '../../services/system'

import { TariffController, TariffScope } from './tariffs.controller'
import { TariffCreateEditDirective } from './create-edit/tariffs-create-edit.directive'
import { TariffDetailsDirective } from './details/tariffs-details.directive'
import { TARIFF_COPY_SUMMARY_NAME } from './components'
import { TariffCopySummaryComponent } from './components/tariff-copy-summary/tariff-copy-summary.component'

//#region Asset Imports


import * as TEMPLATE from './tariffs.tpl.html'

//#endregion

// #region Consts

const CONTROLLER_NAME: string = 'TariffController'
const CREATE_EDIT_DIRECTIVE_NAME: string = 'tariffCreateEdit'
const DETAILS_DIRECTIVE_NAME: string = 'tariffDetails'
const MENU_INDEX = 9.1
const MODULE_NAME: string = 'simax.tariffs'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'TARIFF_NAME'
const STATE_NAME: string = 'tariffs'
const STATE_URL: string = '/tariffs'

// #endregion


// #region Setup

const module = angular.module(MODULE_NAME, [commonModule, apiModule, SERVICES_MODULE_NAME])

module.controller(CONTROLLER_NAME, [
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    'api',
    'logger',
    'localDictionary',
    USER_SESSION_SERVICE_NAME,
    GRID_SERVICE_NAME,
    GRID_CONTEXT_MENU_SERVICE_NAME,
    TARIFF_SERVICE_NAME,
    SYSTEM_SERVICE_NAME, (
        $scope: TariffScope,
        $state: StateService,
        $timeout,
        api: Api,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        userSessionService: UserSessionService,
        gridService: GridService,
        gridContextMenuService: GridContextMenuService,
        tariffService: TariffService,
        systemService: SystemService
    ) => new TariffController(
        $scope,
        $state,
        $timeout,
        api,
        logger,
        localDictionary,
        userSessionService,
        gridService,
        gridContextMenuService,
        tariffService,
        systemService,
        TariffService.REFERENCE_TYPE,
        TariffService.SIMAX_MODULE_NAME
    )])

module.directive(DETAILS_DIRECTIVE_NAME, [() => new TariffDetailsDirective()])
module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new TariffCreateEditDirective()])
module.component(TARIFF_COPY_SUMMARY_NAME, new TariffCopySummaryComponent())

module.config([$STATE_SERVICE_PROVIDER_NAME, USER_SESSION_SERVICE_PROVIDER_NAME, SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionProvider: UserSession,
    systemServiceProvider: SystemServiceProvider
) => {
    systemServiceProvider.registerDetailsComponent({
        key: 'Tariff_IdTariff',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {

            if (loggedOperator.hasPermission(Activity.TARIFF_LIST)
                && !loggedOperator.hasPermission(Activity.TARIFF_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.TariffModule)) {

                MenuItem.addMenuItem(
                    ConfigHelper.getIconName(ConfigHelper.Icon.TARIFF),
                    'tariffs',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME,
                    MENU_INDEX
                )

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLLER_NAME,
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

// #endregion


export default MODULE_NAME